import { createSelector } from 'reselect';
import { PRACTICE, QUESTIONS } from '../../constants/assessmentItemType';

export const getVocabBDContent = (state, pageType, questionIndex = 0) => {
    let content;

    switch (pageType) {
        case PRACTICE:
            content = state.practice;
            break;
        case QUESTIONS:
            content = state.questions;
            break;
        default:
            content = [{}];
    }

    return content[questionIndex] || {};
};

export const getIsVocabBDDataFetched = state => state.isDataFetched;

export const getVocabBDStimulusInfo = createSelector(
    [getVocabBDContent],
    content => content.stimulus || {},
);

export const getVocabBDPossibleResponses = createSelector(
    [getVocabBDContent],
    content => content.possibleResponses || [],
);

export const getVocabBDTotalQuestions = state => state.questions.length;

export const getVocabBDFormId = state => state.formId;

export const getVocabBDSelectedResponseId = (state, pageType, questionIndex, responseIdx) => {
    const possibleResponses = getVocabBDPossibleResponses(state, pageType, questionIndex);

    if (possibleResponses && possibleResponses[responseIdx]) {
        return possibleResponses[responseIdx].id;
    }

    return undefined;
};
